import { Params } from '@angular/router';

import * as fromRouter from '@ngrx/router-store';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { differenceInCalendarDays, parse } from 'date-fns';

import { routerState, RouterState, selectQueryParams } from '@rx-applications/shared/data-access';
import { AppRoutes } from '../../constants';

export const STORE_NAME = 'router';

export const {
  selectCurrentRoute, // select the current route
  // selectFragment, // select the current route fragment
  // selectQueryParams, // select the current route query params
  // selectQueryParam, // factory function to select a query param
  // selectRouteParams, // select the current route params
  // selectRouteParam, // factory function to select a route param
  // selectRouteData, // select the current route data
  selectUrl, // select the current url
} = fromRouter.getSelectors(routerState);

export const selectState = createSelector(routerState, (state: RouterState) => state && state.state);

export const selectIsOnAccountPages = createSelector(
  selectUrl,
  (url: string) => url.includes(AppRoutes.Account) || url.includes(AppRoutes.Analytics) || url.includes(AppRoutes.RoomexPay),
);

export const selectIsOnGuestDetailsPage = createSelector(
  selectUrl,
  (url: string) => !!url && url.includes(AppRoutes.GuestDetails),
);

export const selectIsOnApprovalRequestPage = createSelector(
  selectUrl,
  (url: string) => !!url && url.includes(AppRoutes.ApprovalRequestUrlPattern),
);

export const selectIsOnGuestDetailsGatewayPage = createSelector(
  selectUrl,
  (url: string) => !!url && url.includes(AppRoutes.GuestDetailsGateway),
);

export const selectIsOnTripHubPages = createSelector(
  selectUrl,
  (url: string) =>
    url.includes(AppRoutes.ReportBookers) || url.includes(AppRoutes.ReportHotels) || url.includes(AppRoutes.ReportTraveler),
);

export const selectIsOnClientFieldPages = createSelector(selectUrl, (url: string) =>
  url.includes(AppRoutes.ReportClientfield),
);

export const selectNumberOfNights = createSelector(routerState, (state: RouterState) => {
  if (!state || !state.state || !state.state.queryParams) {
    return 0;
  }
  return differenceInCalendarDays(
    parse(state.state.queryParams['checkoutDate'], 'yyyy-MM-dd', new Date()),
    parse(state.state.queryParams['checkinDate'], 'yyyy-MM-dd', new Date()),
  );
});

export const selectLocationCode = createSelector(
  routerState,
  (state: RouterState) => state.state.queryParams['locationCode'],
);

export const selectAreSearchParamsSet = createSelector(
  routerState,
  (state: RouterState) =>
    state &&
    state.state &&
    state.state.queryParams['rooms'] &&
    state.state.queryParams['checkinDate'] &&
    state.state.queryParams['checkoutDate'],
);

export const selectQueryParamStars: MemoizedSelector<RouterState, number[]> = createSelector(
  selectQueryParams,
  (queryParams: Params) => {
    const stars = queryParams['stars'];
    return stars ? stars.split(',').map((star: string) => +star) : [];
  },
);
